import { apiService } from "./api";

export interface JobCardActivitySummary {
  jobcard_no: string;
  vin_no: string;
  vin_date: string;
  customer_name: string;
  vehicle_no: string;
  current_status: string;
  service_advisor: string;
  service_advisor_id?: string;
}

export interface JobCardActivityItem {
  id: string;
  module: string;
  activity_name: string;
  status: string;
  occurred_at: string;
  actor_user_id?: string;
  actor_name?: string;
  actor_username: string;
  description?: string | null;
  remarks?: string | null;
  additional_info?: Record<string, string | number> | null;
}

export interface JobCardActivityAuditResponse {
  success: boolean;
  totalcount?: number;
  summary?: JobCardActivitySummary;
  activities?: JobCardActivityItem[];
  message?: string;
}

export async function fetchJobCardActivityAudit(
  jobcardId: string,
  skip = 0,
  limit = 100
): Promise<JobCardActivityAuditResponse> {
  return apiService.get<JobCardActivityAuditResponse>(
    `/pabws/jobcard/${encodeURIComponent(jobcardId)}/activity-audit`,
    { skip, limit },
    { includeAuthToken: true, authHeaderType: "Bearer" }
  );
}
